export const createHash = (value?: string, prefix = 'hash_') => {
  if (!value) return null

  let hash = 0
  for (let i = 0; i < value.length; i += 1) {
    const char = value.charCodeAt(i)
    hash = hash * 31 + char
    hash = Math.abs(hash) % 2147483647 // Convert to positive 32-bit integer
  }
  return `${prefix}${hash.toString(36)}`
}
